import { render, staticRenderFns } from "./index.vue?vue&type=template&id=81ee410e&scoped=true&"
import script from "./component.js?vue&type=script&lang=js&"
export * from "./component.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=81ee410e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ee410e",
  null
  
)

export default component.exports